import { createElementVNode as _$ce, createUnknownComponentVNode as _$cc, className as _$cn } from 'intact-vue';
import { getClassAndStyleForFixed } from './useFixedColumns';
import { get, noop } from 'intact-shared';
import { Button } from '../button';
import { Icon } from '../icon';
import { getTextByChildren } from '../utils';
export default function ($props, $blocks, $__proto__) {
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    props = _this$get.props,
    rowIndex = _this$get.rowIndex,
    columnIndex = _this$get.columnIndex,
    offset = _this$get.offset,
    data = _this$get.data,
    checkType = _this$get.checkType,
    indent = _this$get.indent,
    grid = _this$get.grid,
    colspan = _this$get.colspan,
    rowspan = _this$get.rowspan,
    onClickArrow = _this$get.onClickArrow,
    hasChildren = _this$get.hasChildren;
  var k = this.config.k;
  var blocks = props.$blocks;
  var children = get(data, props.key);
  if (blocks) {
    var template = blocks.template || blocks.default;
    if (template) {
      children = template(noop, [data, rowIndex]);
    }
  }
  var _getClassAndStyleForF = getClassAndStyleForFixed(props, offset, k, checkType),
    className = _getClassAndStyleForF.className,
    style = _getClassAndStyleForF.style;
  if (columnIndex === 0 && indent) {
    style || (style = {});
    style.paddingLeft = indent + "px";
  }
  return _$ce(2, 'td', [columnIndex === 0 && hasChildren ? _$cc(Button, {
    'type': 'none',
    'icon': true,
    'circle': true,
    'size': 'mini',
    'className': _$cn(k + "-table-arrow"),
    'ev-click': onClickArrow,
    'children': _$cc(Icon, {
      'className': _$cn(k + "-icon-right"),
      'size': 'small'
    })
  }) : undefined, children], 0, _$cn(className), {
    'style': style,
    'title': getTextByChildren(children),
    'rowspan': rowspan,
    'colspan': colspan
  });
}
;